import styled from '@emotion/styled';
import { Image, Separator } from '@chakra-ui/react';
import { HStack } from 'components/ui';
import { useAffiliate } from '../../api/affiliates/useAffiliate';

const ImgContainer = styled('span')`
  & > div > div {
    background-position: left;
  }
`;

type Props = {
  variant?: 'regular' | 'small' | 'new';
};

export const CoBrandingLogo = ({ variant = 'regular' }: Props) => {
  const { affiliate } = useAffiliate();
  const { logo: affiliateLogo, utm_source: affiliateUtmSource } =
    affiliate || {};

  if (!affiliateLogo) return null;

  const mx = variant === 'new' ? 2 : variant === 'regular' ? 8 : 4;
  const dividerHeight = variant === 'new' ? '50px' : '50%';
  const dividerColor = variant === 'new' ? 'secondary.200' : 'white';
  return (
    <HStack alignItems={'center'}>
      <ImgContainer>
        <Image
          alt={`${affiliateUtmSource} logo`}
          maxHeight={'50px'}
          objectFit={'contain'}
          boxSize={variant === 'regular' || variant === 'new' ? 'xl' : 'md'}
          src={affiliateLogo}
          data-testid={'cobranding-logo'}
        />
      </ImgContainer>

      <Separator
        bgColor={dividerColor}
        height={dividerHeight}
        orientation={'vertical'}
        mx={mx}
        data-testid={'cobranding-divider'}
        width={'1px'}
      />
    </HStack>
  );
};
